"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _reactSelect = require("react-select");

var _classnames = _interopRequireDefault(require("classnames"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Option = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(Option, _React$Component);

  var _super = _createSuper(Option);

  function Option() {
    (0, _classCallCheck2.default)(this, Option);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(Option, [{
    key: "render",
    value: function render() {
      var option = this.props.option;
      var disabled = option.header || option.divider || option.disabled;
      var className = (0, _classnames.default)(this.props.className, {
        'is-header': option.header,
        'is-divider': option.divider,
        'is-disabled': disabled
      });

      var newOption = _objectSpread({}, option);

      if (disabled) {
        newOption.disabled = disabled;
      }

      return /*#__PURE__*/_react.default.createElement(_reactSelect.Option, (0, _extends2.default)({}, this.props, {
        option: newOption,
        className: className,
        isDisabled: disabled
      }));
    }
  }], [{
    key: "propTypes",
    get: function get() {
      return _objectSpread({}, _reactSelect.Option.propTypes);
    }
  }, {
    key: "defaultProps",
    get: function get() {
      return _objectSpread({}, _reactSelect.Option.defaultProps);
    }
  }]);
  return Option;
}(_react.default.Component);

exports.default = Option;